import { createTheme } from "@material-ui/core/styles";
import { COLORS } from "./colors";

export const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.purple,
    },
    success: {
      main: COLORS.green,
    },
  },
  typography: {
    fontFamily: "Lato",
    h1: {
      fontSize: 30,
      fontWeight: "bold",
      lineHeight: "36px",
    },
    h2: {
      fontSize: 24,
      fontWeight: "bold",
      lineHeight: "28.8px",
    },
    h3: {
      fontSize: 18,
      fontWeight: "bold",
      lineHeight: "24px",
    },
    h4: {
      fontSize: 18,
      lineHeight: "24px",
    },
    h5: {
      fontSize: 14,
      color: COLORS.darks[0][100],
      lineHeight: "22px",
    },
    h6: {
      fontSize: 14,
      color: COLORS.darks[0][100],
      lineHeight: "22px",
    },
    subtitle1: {
      fontSize: "1.1rem",
    },
    body1: {
      fontSize: 14,
      color: COLORS.darks[0][100],
    },
    body2: {
      fontSize: 12,
      color: COLORS.darks[0][100],
    },
    bodySmall: {
      fontSize: 10,
      fontWeight: "bold",
      color: COLORS.darks[0][100],
    },
  },
  overrides: {
    MuiTableContainer: {
      root: {
        boxShadow: "0px 4px 12px rgba(16, 30, 115, 0.06)",
      },
    },
    MuiTable: {
      root: {
        borderRight: `1px solid ${COLORS.darks[0][10]}`,
      },
    },
    MuiTableCell: {
      root: {
        border: `1px solid ${COLORS.darks[0][10]}`,
        borderBottom: "none",
        padding: "2px 10px 3px",
        fontSize: 14,
        borderRight: "none",
      },
      head: {
        fontWeight: 600,
      },
      stickyHeader: {
        borderBottom: `1px solid ${COLORS.darks[0][10]}`,
      },
    },
    MuiTableHead: {
      root: {
        backgroundColor: COLORS.darks[7],
      },
    },
    MuiInput: {
      underline: {
        "&:before": {
          borderBottom: "none",
        },

        "&:hover:not(.Mui-disabled):before": {
          borderBottom: "none",
        },
      },
      multiline: {
        padding: 0,
        width: "100%",
        fontSize: "0.875rem",
        "&:after": {
          borderBottom: "none",
        },
      },
    },
    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: "transparent",
        },
      },
      root: {
        fontSize: "0.9rem",
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: "0.9rem",
      },
    },
    MuiButton: {
      containedPrimary: {
        "&:hover": {
          backgroundColor: COLORS.hovered_purple,
        },
      },
      contained: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
      },
      root: {
        fontSize: "1rem",
      },
    },
    MuiTableSortLabel: {
      icon: {
        marginLeft: 0,
        marginRight: 0,
      },
    },
    MuiCard: {
      root: {
        boxShadow: `0px 12px 26px ${COLORS.darks[0][6]}`,
        borderRadius: 8,
        border: `1px solid ${COLORS.darks[0][15]}`,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: COLORS.darks[0][10],
      },
    },
    MuiToggleButton: {
      root: {
        padding: "1.5px 3px",
        backgroundColor: COLORS.darks[0][25],
        borderRadius: 5,
        "&.Mui-selected": {
          backgroundColor: COLORS.darks[0][100],
          "& p": {
            color: COLORS.white,
            width: 32,
          },
        },
        "& p": {
          color: COLORS.darks[0][100],
          textTransform: "none",
          width: 32,
        },
      },
      label: {
        "&>p": { fontSize: 12 },
      },
    },
    MuiCheckbox: {
      root: {
        padding: 0,
        color: COLORS.darks[0][25],
      },
    },
    MuiTabs: {
      flexContainer: {
        borderBottom: `solid 2px ${COLORS.americanSilver}`,
      },
    },
    MuiTab: {
      root: {
        paddingBottom: 0,
      },
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: "0px !important",
        marginTop: 8,
      },
      label: {
        marginLeft: 8,
      },
    },
    MuiRadio: {
      root: {
        padding: 0,
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: 12,
        fontStyle: "italic",
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 12,
      },
    },
    MuiOutlinedInput: {
      root: {
        borderColor: COLORS.darks[0][10],
      },
    },
    MuiSvgIcon: {
      root: {
        cursor: "pointer",
      },
    },
  },
});
